
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1382|6885|8249|8318)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
